module.exports = __webpack_public_path__ + "static/media/benchmark-cover.054acc43.svg";